import { render, staticRenderFns } from "./DashboardPengendalian.vue?vue&type=template&id=6d4ab3e8&"
import script from "./DashboardPengendalian.vue?vue&type=script&lang=js&"
export * from "./DashboardPengendalian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports